module.exports = __webpack_public_path__ + "assets/img/index-banner1-2.0952fb06.jpg";